import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Header } from '../../components/header';
import { AppState } from '../../store';
import { Help, Search, Time, User } from '../../components/header/components';
import NonOrbcommDevicesConfigurePage from '../../components/configure/non-orbcomm-devices';
import { setSelectedEntityFromDeviceOrTelematicsId } from '../../store/search/actions';
import { useMountEffect } from '../../globals/hooks/use-mount-effect';
import CenteredMessageBox from '../../components/centered-message-box';
import { testIsOrbcomm } from '../../globals/utils';

const Configure: FC = () => {
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const deviceType = selectedEntity?.deviceType;
  const isOrbcommDevice = testIsOrbcomm(deviceType);
  const { deviceId } = useParams<{ deviceId: string }>();
  const dispatch = useDispatch();

  const setEntityFromUrl = useCallback(() => {
    if (deviceId !== selectedEntity?.deviceId) {
      dispatch(setSelectedEntityFromDeviceOrTelematicsId(deviceId));
    }
  }, [deviceId, selectedEntity, dispatch]);

  useMountEffect(() => {
    setEntityFromUrl();
  });
  const notAvailableDeviceTypes = ['PL161', 'PL161SC'];
  let body = <NonOrbcommDevicesConfigurePage />;
  if (isOrbcommDevice) {
    body = (
      <CenteredMessageBox message="Configuration page functions not applicable for Orbcomm devices." />
    );
  } else if (!selectedEntity?.deviceType) {
    body = (
      <CenteredMessageBox message="Configuration page functions not applicable for Assets without Attached Devices." />
    );
  } else if (notAvailableDeviceTypes.includes(selectedEntity?.deviceType)) {
    body = <CenteredMessageBox message="Configuration page not available for this device type." />;
  }
  return (
    <Box>
      <Header
        title="Configuration"
        headerComponents={deviceId ? [<Help userLink='/SitePages/Configuration-Page.aspx?promotedState=0'/>, <Search page="configure" />, <Time />, <User />] : [<Help userLink='/SitePages/Search-Page-Manual.aspx'/>, <Time suppressPopover />, <User />]}
      />
      {body}
    </Box>
  );
};

export default Configure;
